import { html } from '@microsoft/fast-element';
import type { VisuallyHidden } from './visually-hidden.js';

export const visuallyHiddenTemplate = html<VisuallyHidden>`<slot></slot>`;